function getIncorrectlyAnsweredMarkup({ correctAnswerText }) {
  return `<p class="reimagine-quiz-answer"><i class="fa fa-times" aria-hidden="true"></i> The correct answer is: ${correctAnswerText}</p>`;
}

export { getIncorrectlyAnsweredMarkup };